import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import { LogoLayout } from "fe-shared/src/components";

import { ROUTES } from "consts";

import styles from "./AccountCreatedView.module.scss";

const AccountCreatedView = () => {
  const { t } = useTranslation();

  return (
    <LogoLayout>
      <h2 className={styles.header}>{t("accountCreated.title")}</h2>
      <p className={styles.description}>
        <Trans i18nKey="accountCreated.description">
          <Link to={ROUTES.login}>Login</Link>
        </Trans>
      </p>
    </LogoLayout>
  );
};

export default AccountCreatedView;
